import { types } from "../../types/types";

const initialState = {
    data: {}
}


export const diagnosticApiData = (state = initialState, action) => {
    switch (action.type) {
        case types.diagnosticApiData:
            return {
                ...state,
                data: { ...action.payload }
            }
        default:
            return state;
    }
}